<template>
    <div class="social-wrapper">
        <div class="social-divider">
            <p>{{$t('auth.or')}}</p>
        </div>
        <vs-button color="#4a68ad" class="facebook-btn" @click="facebookLogin">Facebook</vs-button>
        <!--<vs-button color="#00c6ff" class="twitter-btn" @click="twitterLogin">Twitter</vs-button>-->
        <vs-button color="#0077b5" class="linkedin-btn" @click="linkedinLogin">Linkedin</vs-button>
    </div>
</template>

<script>
  const { VUE_APP_LINKEDIN_APPID, VUE_APP_LINKEDIN_CALLBACK } = process.env
  /* eslint-disable */

  import Social from '../mixins/Social'

  const scope = ['r_organization_social', 'w_member_social', 'w_organization_social', 'r_basicprofile', 'r_emailaddress', 'r_liteprofile', 'rw_organization_admin']

  export default {
    name: 'component-social',

    data() {
      return {
        form: {
          id: null,
          token: null
        },
        twitter: '',
        popup: false
      }
    },

    mixins: [Social],

    create() {
      this.popup = JSON.parse(localStorage.twitter)
    },

    beforeMount() {
      const uri = window.location.search.substring(1)
      const params = new URLSearchParams(uri)

      const oauth_token = params.get('oauth_token')
      const oauth_verifier = params.get('oauth_verifier')
      const code = params.get('code')

      if (localStorage.twitter_adding_page || localStorage.linkedin_adding_page) {
        return this.$router.replace({ page: 'pages' })
      }
      console.log('beforeMount', params)

      // Social callbacks
      if (code) {
        this.$vs.loading({ color: 'primary' })
        this.postLinkedinVerify({ code }).then(res => {
          this.$vs.loading.close()
          // Register page
          this.$emit('linkedin-connected', { ...res.data, dry: true })
          // Remove params from URL
          this.$router.push({ name: 'bots' })
        })
      } else if (oauth_token && oauth_verifier) {
        this.$vs.loading({ color: 'primary' })
        this.postTwitterVerify({ oauth_token, oauth_verifier }).then(res => {
          this.$vs.loading.close()
          console.log('postTwitterVerify res.data', res.data)
          this.$emit('twitter-connected', res.data)
        })
      }
    },

    methods: {
      /**
       * Twitter Login - Auth page display
       */
      twitterLogin() {
        this.$ga.event('auth', 'connect-twitter')
        this.getTwitterRedirectLink({}).then(res => {
          if (!res || !res.data)
            return console.error('Problem with Twitter connect')
          window.location.href = res.data.url
        })
      },

      /**
       * Linkedin Login - Auth page display
       */
      linkedinLogin() {
        this.$ga.event('auth', 'connect-linkedin')
        const url = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${VUE_APP_LINKEDIN_APPID}&redirect_uri=${VUE_APP_LINKEDIN_CALLBACK}&scope=${scope.join('%20')}`
        window.location.href = url
      },

      /**
       * Twitter Login - Cancel
       */
      cancel() {
        this.popup = false
        localStorage.setItem('twitter', this.popup)
      },

      /**
       * Facebook Login
       */
      facebookLogin() {
        this.$ga.event('auth', 'facebook-twitter')
        FB.login(
          response => {
            if (response.status === 'connected') {
              let uid =
                    (response.authResponse && response.authResponse.userID) || null
              let accessToken = response.authResponse.accessToken

              this.$vs.loading({ color: 'primary' })
              this.getUserInfoFb(accessToken).then(res => {
                let success = res.ok
                if (!success || success !== true) {
                  this.dialog.title = 'Error'
                  if (!res.body) {
                    this.dialog.message = 'Server not responding…'
                  } else {
                    this.dialog.message = res.statusText
                  }
                  this.dialog.show = true
                  return
                }

                let user = res.data

                this.getLongLiveToken(accessToken).then(res => {
                  let success = res.ok
                  if (!success || success !== true) {
                    this.dialog.title = 'Error'
                    if (!res.body) {
                      this.dialog.message = 'Server not responding…'
                    } else {
                      this.dialog.message = res.statusText
                    }
                    this.dialog.show = true
                    return
                  }
                  let body = {
                    id: uid,
                    token: res.body.access_token
                  }
                  localStorage.setItem('facebook', JSON.stringify(body))

                  this.retrievePages(body.token).then(res => {
                    let success = res.ok
                    if (!success || success !== true) {
                      this.dialog.title = 'Error'
                      if (!res.body) {
                        this.dialog.message = 'Server not responding…'
                      } else {
                        this.dialog.message = res.statusText
                      }
                      this.dialog.show = true
                      return
                    }

                    let facebook = []
                    res.body.data.forEach(page => {
                      let newPage = {}
                      Object.keys(page).forEach(key => {
                        var value = page[key]
                        if (key === 'id') {
                          key = 'network_id'
                        } else if (key === 'picture') {
                          key = 'avatar'
                          value = value.data.url
                        }
                        newPage[key] = value
                      })
                      facebook.push(newPage)
                    })

                    localStorage.setItem(
                      'facebookPages',
                      JSON.stringify(facebook)
                    )
                    this.$vs.loading.close()
                    this.$emit('facebook-connected', body, user)
                  })
                })
              })
            }
          },
          {
            scope:
              'public_profile, email',
            return_scopes: true
          }
        )
      },

      /**
       * Facebook Logout
       */
      facebookLogout() {
        FB.getLoginStatus(function (response) {
          if (response.status === 'connected') {
            FB.logout(function () {
              FB.Auth.setAuthResponse(null, 'unknown')
            })
          } else if (response.status === 'not_authorized') {
            // the user is logged in to Facebook,
            // but has not authenticated your app
          } else {
            // the user isn't logged in to Facebook.
            console.log('response status not logged in')
          }
        })
      }
    }
  }
</script>
